import { Component, Input, inject } from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { EnaioDocument } from 'src/modules/enaio/shared/EnaioDocument';
import { EnaioMetaDataField } from 'src/modules/enaio/shared/EnaioMetaDataField';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableCell } from 'src/modules/sm-base/models/table-cell.model';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'enaio-document-meta-data',
    templateUrl: './document-meta-data.component.html',
    styleUrls: []
})
export class DocumentMetaDataComponent {

    app: MainAppService = inject(MainAppService);

    _document: EnaioDocument = null;
    metaData: EnaioMetaDataField[] = null;
    table: TableData;
    @Input()
    anonymousGuid: string;

    @Input()
    set document(value: EnaioDocument) {
        this._document = value;
        this.metaData = this._document != null ? this._document.metaData : null;
        if (this._document != null) {
            if (!Utils.isNoe(this.anonymousGuid)) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                RestEndpoint.main().query({anonymousGuid: this.anonymousGuid, id: this._document.id}).run("api/doc/def/anonymousobject").get(EnaioDocument).then(result => {
                    this.metaData = result.metaData;
                    this.filterMetaData();
                });
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                RestEndpoint.main().findById(this._document.id).run("api/doc/document/object").get(EnaioDocument).then(result => {
                    this.metaData = result.metaData;
                    this.filterMetaData();
                });
            }
        }
        this.filterMetaData();
    }

    get document(): EnaioDocument {
        return this._document;
    }

    private filterMetaData(): void {
        this.metaData = this.metaData?.filter(field => !field.field.system);
    /*    this.metaData = this.metaData?.map(field => {
            if (typeof field.value == 'number') {
                field.value = field.value ? 'Ja' : 'Nein';
            }
            return field;
        });
        console.log('metaData: ', this.metaData);
      */  
        this.table = new TableData([
            new TableColumn("field", this.app.t("general.property"), TableCellType.text, { autoWidth: 30 }),
            new TableColumn("value", this.app.t("general.value"), TableCellType.text, { flex: 1 })
        ], (this.metaData ?? []).map(md => new TableRow("", md, {
                field: this._document != null ? this.app.t("objectDef." + this._document.objectType.name + "." + md.field.name, null, md.field.getBestDisplayName()) : md.field.getBestDisplayName(),
                value: new TableCell(Utils.replaceAll(md.getDisplayValue(), "\\\n", "<br>"), { keepHtml: true })
            })));
    }

}
